import usePressEvents from './usePressEvents';
import { useParams } from 'react-router-dom';

export default function useEventDetails() {
  const { sections, isLoading } = usePressEvents();
  const { slug } = useParams();
  
  const items = sections?.map((tag) => tag.fields.sliderItems.map((t) => t.fields));
  const event = items.map((elem) => elem.find((w) => (w.slug === slug))).slice(1);
  
  const image = event[0]?.eventDetails?.fields.eventImage?.fields.file.url || '';
  const titleEvent = event[0]?.eventDetails?.fields.title || '';
  const descriptionEvent = event[0]?.eventDetails?.fields.descriptionEvent || '';
  const resourceLinks = event[0]?.eventDetails?.fields.resourceLinks || '';
  
  return {
    image,
    titleEvent,
    descriptionEvent,
    resourceLinks,
    isLoading
  };
}
